import { render, staticRenderFns } from "./AddPay.vue?vue&type=template&id=c236d520&scoped=true"
import script from "./AddPay.vue?vue&type=script&lang=js"
export * from "./AddPay.vue?vue&type=script&lang=js"
import style0 from "./AddPay.vue?vue&type=style&index=0&id=c236d520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c236d520",
  null
  
)

export default component.exports